import { Routes } from '@angular/router';
import { ToolAdminGuard } from './core/guards/tool-admin-guard.service';
import { IPageHeader } from './layout/page-header/page-header.component';
import { ForbiddenComponent } from './pages/app/forbidden/forbidden.component';
import { PageNotFoundComponent } from './pages/app/page-not-found/page-not-found.component';
import { TypographyComponent } from './pages/app/typography/typography.component';
import { DashboardContentAdvancedFilterResolver } from './pages/dashboard-content/dashboard-content-advanced-filter.resolver';
import { DashboardContentComponent } from './pages/dashboard-content/dashboard-content.component';
import { DashboardContentResolver } from './pages/dashboard-content/dashboard-content.resolver';
import { DashboardsComponent } from './pages/settings/dashboards/dashboards.component';
import { DASHBOARDS_ROUTE_PATHS } from './pages/settings/dashboards/dashboards.paths';
import { DataIntegrationsComponent } from './pages/settings/data-integrations/data-integrations.component';
import { FormSubmissionsComponent } from './pages/settings/form-submissions/form-submissions.component';
import { FormComponent } from './pages/settings/form/form.component';
import { UsersTeamsComponent } from './pages/settings/users-teams/users-teams.component';
import { SlideshowContentComponent } from './pages/slideshows/slideshow-content/slideshow-content.component';
import { SlideshowContentResolver } from './pages/slideshows/slideshow-content/slideshow-content.resolver';
import { CountdownManager } from './shared/components/countdown/countdown-manager.class';
import { HeaderBreadcrumbManager } from './shared/components/header-breadcrumb/header-breadcrumb-manager';
import { PageViewAndEditModeSwitchManagerResolver } from './shared/components/page-view-and-edit-mode-switch/page-view-and-edit-mode-switch-manager.resolver';
import { FilterSettingsComponent } from './pages/settings/filter-settings/filter-settings.component';

const dashboardsBreadcrumbManager = new HeaderBreadcrumbManager();

export const routes: Routes = [
  {
    component: DashboardsComponent,
    data: {
      icon: 'dashboard',
      title: 'page.dashboards.title',
    },
    outlet: '',
    path: DASHBOARDS_ROUTE_PATHS.list,
    resolve: {
      headerBreadcrumbManager: () => dashboardsBreadcrumbManager,
    },
  },
  {
    component: DashboardsComponent,
    data: {
      icon: 'dashboard',
      title: 'page.dashboards.title',
    },
    outlet: '',
    path: DASHBOARDS_ROUTE_PATHS.children,
    resolve: {
      headerBreadcrumbManager: () => dashboardsBreadcrumbManager,
    },
  },
  { path: '', pathMatch: 'full', redirectTo: '/dashboards' },
  {
    children: [
      {
        canActivate: [ToolAdminGuard],
        component: UsersTeamsComponent,
        data: { icon: 'person', title: 'page.usersAndTeams.title' },
        outlet: '',
        path: 'users',
      },
      {
        canActivate: [ToolAdminGuard],
        component: FormComponent,
        data: { icon: 'assignment', title: 'page.forms.title' },
        outlet: '',
        path: 'forms',
      },
      {
        canActivate: [ToolAdminGuard],
        component: FormSubmissionsComponent,
        data: { icon: 'assignment', title: 'page.formSubmissions.title' },
        outlet: '',
        path: 'form-submissions',
      },
      {
        canActivate: [ToolAdminGuard],
        component: DataIntegrationsComponent,
        data: { icon: 'public', title: 'page.dataIntegrations.title' },
        outlet: '',
        path: 'data-integrations',
      },
      {
        canActivate: [ToolAdminGuard],
        component: FilterSettingsComponent,
        data: { icon: 'public', title: 'page.filterSettings.title' },
        outlet: '',
        path: 'filters',
      },
    ],
    path: 'settings',
  },
  {
    children: [
      {
        component: ForbiddenComponent,
        data: { icon: 'lock', title: 'page.forbidden.title' },
        outlet: '',
        path: 'forbidden',
      },
    ],
    path: 'error',
  },
  {
    component: DashboardContentComponent,
    data: {
      icon: 'dashboard',
      title: 'page.dashboards.title',
    } as IPageHeader,
    path: DASHBOARDS_ROUTE_PATHS.content,
    providers: [DashboardContentResolver],
    resolve: {
      advancedFilterManager: DashboardContentAdvancedFilterResolver,
      countdownManager: () => new CountdownManager(5),
      dashboard: DashboardContentResolver,
      pageViewAndEditModeSwitchManager: PageViewAndEditModeSwitchManagerResolver,
    },
  },
  {
    component: DashboardContentComponent,
    data: {
      icon: 'dashboard',
      title: 'page.dashboards.title',
    } as IPageHeader,
    path: 'dashboard/:id',
    providers: [DashboardContentResolver],
    resolve: {
      advancedFilterManager: DashboardContentAdvancedFilterResolver,
      countdownManager: () => new CountdownManager(5),
      dashboard: DashboardContentResolver,
      pageViewAndEditModeSwitchManager: PageViewAndEditModeSwitchManagerResolver,
    },
  },
  {
    component: SlideshowContentComponent,
    data: {
      icon: 'slideshows',
      showSlideshowController: true,
      title: 'page.slideshows.title',
    } as IPageHeader,
    path: 'slideshows/:id',
    providers: [SlideshowContentResolver],
    resolve: {
      countdownManager: () => new CountdownManager(5),
      slideshow: SlideshowContentResolver,
    },
  },
  {
    component: TypographyComponent,
    data: { icon: 'format_color_text', title: 'page.typography.title' },
    path: 'typography',
  },
  { component: PageNotFoundComponent, data: { icon: 'find_in_page', title: 'page.notFound.title' }, path: '**' },
];
